import React, { useEffect, useState } from 'react';
import classes from './Chart.module.css';
import {
    Area,
    AreaChart,
    CartesianGrid,
    Label,
    Line,
    LineChart,
    ReferenceLine,
    XAxis,
    YAxis,
} from 'recharts';

const Chart = ({ data, minX, maxX, minY, maxY }) => {
    const referensePoint = data[0]?.value || 0;
    // console.log(data.length, (data[data.length - 1]?.timestamp - data[0]?.timestamp) / 1000);
    // console.log('разница', data[1]?.timestamp - data[0]?.timestamp);

    return (
        <div className={classes.chart}>
            <LineChart
                responsive
                margin={{ top: 10, right: 45, bottom: -5, left: 0 }}
                width="100%"
                height="100%"
            >
                <CartesianGrid strokeDasharray="3 3" />

                <YAxis
                    dataKey="value"
                    domain={[minY, maxY]}
                    type="number"
                    interval={0}
                    width="auto"
                />

                <XAxis dataKey="timestamp" domain={[minX, maxX]} interval={0} type="number" />
                {/* <XAxis dataKey="x" domain={[minX, maxX]} interval={0} type="number">
                    <Label value="Время, секунд назад" offset={-10} position="insideBottom" />
                </XAxis> */}
                <ReferenceLine
                    y={referensePoint} // Используем 0 как значение по умолчанию
                    stroke="blue"
                    strokeDasharray="5 5"
                    strokeWidth={2}
                    label={
                        referensePoint !== undefined
                            ? {
                                  value: `${referensePoint.toFixed(1)}`,
                                  position: 'right',
                                  fill: 'blue',
                                  fontSize: 14,
                              }
                            : null // Если данных нет, не отображаем метку
                    }
                />

                <Line
                    strokeWidth={3}
                    data={data}
                    dot={false}
                    // type="linear"
                    type="monotone"
                    dataKey="value"
                    stroke="red"
                    tooltipType="none"
                    // animationDuration={500} // Анимация займет 0.5 секунды
                    isAnimationActive={false}
                />
            </LineChart>
        </div>
    );
};

export default Chart;

